import React, { useEffect, useState, useMemo } from "react";
import { Flex } from "@chakra-ui/react";
import NavItem from "../NavItem/NavItem";
import { useLocation } from "react-router-dom";

// Bootstrap Icons (react-icons/bs)
import {
  BsHouse,
  BsPersonVcard,
  BsPeople,
} from "react-icons/bs";
import { ARCHIVE_MODE_ENABLED } from "../../../../../../../archive/archiveConfig";

export default function SidebarPage() {
  const [navSize] = useState("large");
  const [activeNavItem, setActiveNavItem] = useState(""); 
  const location = useLocation();

  const subItemsOperation = useMemo(
    () => [
      { to: "", title: "Performans" },
      { to: "", title: "Reklamlar" },
      { to: "", title: "Faydalar" },
    ],
    []
  );

  useEffect(() => {
    if (checkToValue(subItemsOperation, location.pathname)) {
      handleNavItemClick("Satış");
    } else {
      handleNavItemClick("Ana Sayfa");
    }
  }, [location.pathname, subItemsOperation]);

  const checkToValue = (items, targetTo) => {
    return items.some((item) => item.to === targetTo);
  };

  const handleNavItemClick = (title) => {
    setActiveNavItem(title);
  };

  return (
    <Flex
      pos="sticky"
      backgroundColor="#f5f5f5"
      h="100vh"
      mt="5"
      boxShadow="0 4px 12px 0 rgba(0, 0, 0, 0.05)"
      borderRadius={navSize === "small" ? "0" : "0"}
      w={navSize === "small" ? "120px" : "200px"}
      flexDir="column"
      justifyContent="space-between"
      overflowY="auto"
      maxHeight="100%"
    >
      <Flex
        p="5%"
        flexDir="column"
        w="100%"
        alignItems={navSize === "small" ? "center" : "flex-start"}
        as="nav"
      >
        <button
          className="w-full"
          onClick={() => handleNavItemClick("Panel Dashboard")}
        >
          <NavItem
            navSize={navSize}
            icon={BsHouse}
            title="EK Cloud"
            to="/dashboard"
            active={activeNavItem === "Panel Dashboard"}
          />
        </button>

        <button
          className="w-full"
          onClick={() => handleNavItemClick("Müşteriler")}
        >
          <NavItem
            navSize={navSize}
            icon={BsPeople}
            title="Müşteriler"
            to="/panel/customers/add"
            active={activeNavItem === "Müşteriler"}
          />
        </button>

        <button
          className="w-full"
          onClick={() => handleNavItemClick("Bilgiler")}
        >
          <NavItem
            navSize={navSize}
            icon={BsPersonVcard}
            title="Bilgiler"
            to="/customer/information/edit"
            active={activeNavItem === "Bilgiler"}
          />
        </button>

        {!ARCHIVE_MODE_ENABLED && (
          <>
          </>
        )}
      </Flex>
    </Flex>
  );
}
